<template>
    <div class="content-course-box__item swap-item" :class="{ no_valid: !isValid }">
        <div class="content-course-box__head">
            <div class="content-course-box__action">
                <v-icon src="drag" />
            </div>
            <div class="content-course-box__title content-course-box__title_delete">
                Лекция {{ index + 1 }}
                <button class="__clean-btn" @click="$emit('remove', { index, slug: lecture.slug })">
                    <v-icon src="delete" />
                </button>
            </div>
        </div>
        <div class="content-course-box__body">
            <div class="content-course-box__name">
                <div class="form-group form-group_numeric">
                    <label>Название лекции</label>
                    <v-input
                        :max="40"
                        :counter="true"
                        name="name"
                        placeholder="Например: “Photoshop с нуля”"
                        v-model="lecture.name"
                    ></v-input>
                </div>
            </div>
            <MaterialFilledComponent
                v-if="!['v-material', 'v-material-video', 'v-description'].includes(currentComponent)"
                :materials="{
                    videoData: { video: lecture.video, poster: lecture.preview, track: lecture.preview },
                    resources,
                    description: lecture.description
                }"
                :fillerId="lecture.id"
                :config="lecture"
                @emitData="handlerData"
            />

            <component
                :is="currentComponent"
                @emitData="setCurrentComponent"
                :config="lecture"
                :isEdit="isEdit"
            ></component>
        </div>
        <label v-if="!isValid" class="input-error">
            {{ "Требуется указать имя и описание лекции" }}
        </label>
    </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import LectureAddMaterial from "./LectureAddMaterial";
import Description from "../../editor/pages/main-info/components/Description";
import Material from "./Material";
import MaterialVideo from "./MaterialVideo";

import MaterialFilledComponent from "./MaterialFilledComponent";

import { uploadFile } from "../../../course-module/course-creating/services/course-creating-service";
import EventBus from "../../../course-module/course-creating/services/EventBus";

export default {
    name: "LectureComponent",
    props: {
        lecture: {
            type: Object,
            default: () => ({})
        },
        index: {
            type: Number,
            default: 0
        }
    },
    components: {
        "v-add-materials": LectureAddMaterial,
        "v-description": Description,
        "v-material": Material,
        "v-material-video": MaterialVideo,
        MaterialFilledComponent
    },
    data() {
        return {
            currentComponent: "v-add-materials",
            isEdit: false,
            resources: [],
            isValid: true
        };
    },
    beforeDestroy() {
        EventBus.$off("checkValid");
        EventBus.$off("setTrueValid");
    },
    methods: {
        handlerData(action) {
            if (action.name === "navigation") {
                this.isEdit = true;
                this.currentComponent = action.to;
            }
            if (action.name === "remove") {
                this.updateDescription("");
            }
        },
        setCurrentComponent(action) {
            if (action.name === "navigation") {
                this.isEdit = false;
                this.currentComponent = action.to;
            }
            if (action.name === "resource") {
                this.addResource(action.file);
            }
            if (action.name === "saveVideo") {
                this.saveVideoData(action.data);
            }
            if (action.name === "saveDesc") {
                this.updateDescription(action.text);
            }
        },
        addResource(file) {
            uploadFile({ file: file.file })
                .then(res => {
                    const data = res.data.data;
                    // eslint-disable-next-line no-prototype-builtins
                    if (this.lecture.resources.hasOwnProperty("userfiles")) {
                        this.lecture.resources.userfiles.push({
                            src: data.url,
                            name: data.name,
                            id: data.id
                        });
                    } else {
                        this.lecture.resources.data.push({
                            src: data.url,
                            name: data.name,
                            id: data.id
                        });
                    }

                    this.resources.push(data.name);
                })
                .catch(err => {
                    alert(err.statusText);
                });
        },
        saveVideoData(data) {
            // this[LEARNING_LECTURE_VIDEO_SAVE]({
            //     chapterId: this.chapterId,
            //     lectureId: this.config.id,
            //     videoData: data
            // });
            this.currentComponent = "v-add-materials";
        },
        updateDescription(text) {
            const newLecture = { ...this.lecture };
            newLecture.description = text;
            this.$emit("edit", { id: this.index, lecture: newLecture });
            this.lecture = newLecture;
            this.$parent.$children.forEach(component => component.$forceUpdate());
            this.currentComponent = "v-add-materials";
        }
    },

    mounted() {
        // eslint-disable-next-line no-prototype-builtins
        this.resources = this.lecture.resources.hasOwnProperty("userfiles")
            ? this.lecture.resources.userfiles.map(e => e.name)
            : [];

        EventBus.$on("checkValid", id => {
            this.isValid = [!!this.lecture.name, !!this.lecture.description].every(item => item);
            this.$forceUpdate();
        });
        EventBus.$on("setTrueValid", id => {
            this.isValid = true;
        });
    }
};
</script>

<style scoped>
.no_valid {
    border: 1px solid red;
}
</style>
